import { loadStripe, type Stripe } from "@stripe/stripe-js";

/**
 * One Stripe.js load per document. A second `loadStripe` yields a second Stripe
 * instance, and Elements created by one cannot be confirmed by the other — it
 * fails only at confirm time, with an opaque error.
 *
 * Catch script-load failures (e.g. adblockers, corporate firewalls, or transient
 * network errors) and resolve to `null` so `stripePromise` never triggers an
 * unhandled promise rejection on app boot; `@stripe/react-stripe-js` `<Elements>`
 * accepts `Promise<Stripe | null>` and degrades gracefully when `null`.
 */
export const stripePromise: Promise<Stripe | null> = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
).catch((error) => {
  console.warn("Failed to load Stripe.js:", error);
  return null;
});
